import type { StandaloneKlarnaAuthorizationAddresses } from '~/models/checkout/KlarnaSDKInterfaces';
import FetchFactory from '../factory';
import type { KlarnaSessionResponseModel } from '~/models/checkout/KlarnaSession.api.model';
import type { KlarnaSessionResponse } from '~/models/checkout/KlarnaSession.model';
import { mapKlarnaPaymentMethodToPaymentMethod } from '~/models/checkout/PaymentMethods.model';

const CONTROLLER_PATH = '/api-electra/Klarna';

class KlarnaModule extends FetchFactory<any> {
  async startNewSession(isRetail?: boolean): Promise<KlarnaSessionResponse> {
    if (isRetail) {
      return {} as KlarnaSessionResponse;
    }

    const url = `${CONTROLLER_PATH}/StartNewSession`;
    const response = (await this.get(url)) as KlarnaSessionResponseModel;

    return {
      paymentMethods: response.PaymentMethodCategories.map((method) =>
        mapKlarnaPaymentMethodToPaymentMethod(method),
      ),
      clientToken: response.ClientToken,
      sessionId: response.SessionId,
    };
  }

  async savePaymentAuthorization(
    authorizationToken: string,
    sessionId: string,
  ): Promise<boolean> {
    try {
      const url = `${CONTROLLER_PATH}/SavePaymentAuthorization`;
      await this.post(url, {
        authorization_token: authorizationToken,
        session_id: sessionId,
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  async startNewRetailSession(
    orderGuid: string,
  ): Promise<KlarnaSessionResponse> {
    const url = `${CONTROLLER_PATH}/StartRetailNewSession?orderGuid=${orderGuid}`;
    const response = (await this.get(url)) as KlarnaSessionResponseModel;

    return {
      paymentMethods: response.PaymentMethodCategories.map((method) =>
        mapKlarnaPaymentMethodToPaymentMethod(method),
      ),
      clientToken: response.ClientToken,
      sessionId: response.SessionId,
    };
  }

  async getStandaloneKlarnaAuthorizeData(
    orderGuid: string,
  ): Promise<StandaloneKlarnaAuthorizationAddresses> {
    const url = `${CONTROLLER_PATH}/GetStandaloneKlarnaAuthorizeData?orderGuid=${orderGuid}`;
    const response = (await this.get(
      url,
    )) as StandaloneKlarnaAuthorizationAddresses;

    return response;
  }
}

export default KlarnaModule;
